
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Clock } from "lucide-react";

export default function Coaching() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <main className="flex-1 flex items-center justify-center py-16">
        <div className="text-center max-w-lg mx-auto px-4">
          <div className="mx-auto w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-6">
            <Clock className="h-8 w-8 text-muted-foreground" />
          </div>
          <h1 className="text-3xl font-bold mb-4">Coaching is Taking a Break</h1>
          <p className="text-lg text-muted-foreground mb-2">
            We'll be back in 3 months with an improved coaching experience.
          </p>
          <p className="text-sm text-muted-foreground">
            In the meantime, check out our free articles and ML fundamentals to keep preparing.
          </p>
        </div>
      </main>
      
      <Footer />
    </div>
  );
}
